import { render, staticRenderFns } from "./TransactionHubDialog.vue?vue&type=template&id=016a50a1&"
import script from "./TransactionHubDialog.vue?vue&type=script&lang=js&"
export * from "./TransactionHubDialog.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHubDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports